import React from 'react';
import { useIntl } from 'react-intl';

import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import GenericList from '@ts-core/core/components/GenericList';

import { StudentPracticeSession } from '../../types';
import StudentPracticeSessionCard from '../StudentPracticeSessionCard';

interface StudentPracticeSessionsListProps {
  sx?: SxProps;
  practiceSessions?: StudentPracticeSession[];
  loading?: boolean;

  onPracticeSessionActionClick?: (practiceSession: StudentPracticeSession) => void;

  availableExercisesCount: number;
}

function StudentPracticeSessionsList(props: StudentPracticeSessionsListProps) {
  const { sx, practiceSessions, loading = false, availableExercisesCount, onPracticeSessionActionClick } = props;
  const intl = useIntl();

  function renderEmptyView() {
    return (
      <Typography textAlign="center">
        {intl.formatMessage({ id: 'practiceSessions.webEmptyMessage' })}
        <br />
        {availableExercisesCount > 0 &&
          intl.formatMessage(
            { id: 'practiceSessions.webAvailableExercises' },
            {
              strong: (chunks: any) => <strong>{chunks}</strong>,
              value: availableExercisesCount,
            }
          )}
      </Typography>
    );
  }
  return (
    <Box sx={sx}>
      <GenericList
        items={practiceSessions}
        loading={loading}
        skeletonsCount={10}
        emptyMessage={renderEmptyView()}
        renderItem={(index, practiceSession) => (
          <StudentPracticeSessionCard
            key={index}
            practiceSession={practiceSession}
            loading={loading}
            onPracticeSessionActionClick={onPracticeSessionActionClick}
          />
        )}
      />
    </Box>
  );
}

export default StudentPracticeSessionsList;
